import { createClient } from '@supabase/supabase-js'

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://supa.hipyz.com'
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiYW5vbiIsInJlZiI6InNicC1temgxaHgydWkzZnpmejN4IiwiaXNzIjoic3VwYWJhc2UiLCJpYXQiOjE3NTY2MTAyMTUsImV4cCI6MjA3MjE4NjIxNX0.DgAy-HAJhOkCzn0hEyoImj-a6ELqOvSRKc8WoIht_o8'

export const supabase = createClient(supabaseUrl, supabaseAnonKey)
